import { Box, Skeleton } from '@mui/material';

const MenuLayoutSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        border: '1px solid',
        borderColor: 'lightGray.main',
        borderRadius: '8px',
        bgcolor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      {/* Sidebar Skeleton */}
      <Box
        sx={{
          width: 240,
          borderRight: '1px solid',
          borderColor: 'divider',
          height: '100%',
        }}
      >
        {/* Category Title Skeleton */}
        <Box
          sx={{
            py: 1,
            px: 3,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Skeleton width={150} height={32} />
        </Box>

        {/* Category List Skeleton */}
        {[...Array(10)].map((_, index) => (
          <Box key={index} sx={{ px: 2, py: 1 }}>
            <Skeleton width="80%" height={40} />
          </Box>
        ))}
      </Box>

      {/* Content Skeleton */}
      <Box sx={{ flex: 1, p: 2 }}>
        {[...Array(5)].map((_, index) => (
          <Box
            key={index}
            sx={{
              mb: 2,
              p: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
            }}
          >
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
            >
              <Box sx={{ flex: 1 }}>
                <Skeleton width="60%" height={24} />
                <Skeleton width="80%" height={20} sx={{ mt: 1 }} />
                <Skeleton width="30%" height={20} sx={{ mt: 1 }} />
              </Box>
              <Skeleton width={80} height={24} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MenuLayoutSkeleton;
